export default __webpack_public_path__ + "static/media/sam-and-karen-drenched-hiking.b436363f.jpeg";